export default __webpack_public_path__ + "static/media/microsoft_net.b5a4290c.png";